// LOCAL: shared sidebar primitives. Originally lived inside StandaloneLayout;
// pulled out so per-page side navs (e.g. StoreLayout) can reuse the same
// active-state styling + icon sizing without duplicating the CVA config.
import { cva } from 'class-variance-authority';
import { Icon, type SupportedIcon } from 'corso-admin-ui';

export const sidebarActionVariants = cva(
  'flex items-center gap-x-3 rounded-md p-2 text-xs font-semibold',
  {
    variants: {
      active: {
        [`${false}`]: 'text-neutral-900 hover:bg-neutral-100',
        [`${true}`]: 'bg-neutral-50 text-corso-blue-700',
        // a section heading over its open sub-page, which carries the highlight
        open: 'text-corso-blue-700',
      },
      kind: {
        button: 'w-full',
      },
    },
    defaultVariants: {
      active: `${false}`,
    },
  },
);

export function SidebarIcon({
  active = false,
  icon,
  activeIcon,
}: {
  active?: boolean;
  icon: SupportedIcon;
  activeIcon?: SupportedIcon;
}) {
  return (
    <Icon
      icon={active && activeIcon ? activeIcon : icon}
      className="size-5 shrink-0 lg:size-4 lg:group-data-[collapsed=true]/sidebar:size-5"
    />
  );
}
